import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import { FilteredArea } from "Models/Areas/FilteredArea";

@injectable()
export class AreaSelectionUtil implements IAreaSelectionUtil {

    public findAreaById(areaId: number, collection?: Area[]): Area | undefined {
        if (areaId && collection) {
            for (const element of collection) {
                if (element.id === areaId) {
                    return element;
                }
                else {
                    if (element.children && element.children.length > 0) {
                        const childElement = this.findAreaById(areaId, element.children);
                        if (childElement) {
                            return childElement;
                        }
                    }
                }
            }
        }
        return undefined;
    }

    public getAreaRecursiveParents(area?: Area): Area[] {
        if (!area) {
            return [];
        }
        else {
            const recursiveParents = this.getAreaRecursiveParents(area.parent);
            recursiveParents.push(area);

            return recursiveParents;
        }
    }

    private getTreeNamesRecursiveByArea(area: Area, areas: Area[], paths: string[]): boolean {
        // Keep track if the area has been found
        let found = false;

        areas.forEach(parent => {
            if (parent.id === area.id) {
                // Add parent to path array
                paths.unshift(parent.name);
                found = true;
                // Return so the children won't be searched
                return;
            }

            // Search the area in the children
            if (this.getTreeNamesRecursiveByArea(area, parent.children!, paths)) {
                // Add child to path array
                paths.unshift(parent.name);
                found = true;
                return;
            }
        });

        return found;
    }

    public getTreeNamesByArea(area: Area, areas: Area[]): string[] {
        const paths = [] as string[];
        this.getTreeNamesRecursiveByArea(area, areas, paths);
        return paths;
    }

    private getTreeNamesRecursiveByFilter(filter: string, areas: Area[], currentPath: string[], paths: FilteredArea[], parentFound: boolean) {
        // Loop throug all areas
        areas.forEach(parent => {
            // Copy the currentPath to a new array so we don't mess up the currentPath for the other areas
            const newCurrentPath = [...currentPath, parent.name];
            // Somehow the boolean is hold by reference and not by value so we copy it to a new variable
            let newParentFound = parentFound;

            // See if the filter is in the current area name
            if (newParentFound || parent.name.toLowerCase().indexOf(filter) !== -1) {
                paths.push({ area: parent, path: newCurrentPath });
                newParentFound = true;
            }
            else {
                newParentFound = false;
            }

            this.getTreeNamesRecursiveByFilter(filter, parent.children!, newCurrentPath, paths, newParentFound);
        });
    }

    public getTreeNamesByFilter(filter: string, areas: Area[]): FilteredArea[] {
        const paths = [] as FilteredArea[];
        const currentPath: string[] = [];
        this.getTreeNamesRecursiveByFilter(filter.toLowerCase(), areas, currentPath, paths, false);
        return paths;
    }

    public getFilteredAreaCollection(areas: Area[], filter: string): Area[] {
        const result: Area[] = [];
        filter = filter.toLowerCase();

        areas.forEach(area => {
            const areaName = area.name.toLowerCase();

            if (areaName.indexOf(filter) >= 0) {
                result.push(area);
            }
            else {
                if (area.children && area.children.length > 0) {
                    const fitleredChildren = this.getFilteredAreaCollection(area.children, filter);
                    if (fitleredChildren.length > 0) {
                        result.push(area);
                    }
                }
            }
        });

        return result;
    }

    public getChildrenIds(area?: Area, ids: number[] = []): number[] {
        if (!area) {
            return ids;
        }

        ids.push(area.id);
        area.children!.forEach(child => {
            this.getChildrenIds(child, ids);
        });

        return ids;
    }
}



// WEBPACK FOOTER //
// ./src/Components/AreaSelection/Utils/AreaSelectionUtil.ts